/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_RSUAward_RSUAwardVestingTrancheDto } from '../models/Wealthlane_AwardService_Dtos_RSUAward_RSUAwardVestingTrancheDto';
import type { Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo } from '../models/Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RsuAwardImportService {

    /**
     * @param taskId
     * @param tenantId
     * @param userId
     * @param sessionId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRsuAwardImportBackgroundImport(
        taskId?: string,
        tenantId?: string,
        userId?: string,
        sessionId?: string,
        requestBody?: Wealthlane_Shared_Hosting_Etos_ActivityTracingInfo,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/rsu-award-import/background-import',
            query: {
                'taskId': taskId,
                'tenantId': tenantId,
                'userId': userId,
                'sessionId': sessionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param batchSize
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppRsuAwardImportUpsertRSuCustomVestingTranches(
        batchSize?: number,
        requestBody?: Array<Wealthlane_AwardService_Dtos_RSUAward_RSUAwardVestingTrancheDto>,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/rsu-award-import/upsert-rSUCustom-vesting-tranches',
            query: {
                'batchSize': batchSize,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
